import styles from "./ProfileForm.module.css";
import { ADD_GSTIN, ADD_MONEY, BASE_URL, EXPORT_REQUESTS, GET_USER_GSTIN, SET_DEFAULT_GSTIN, UPDATE_GSTIN, UPDATE_ISSUER, UPDATE_USER_ROLE, UPDATE_VERIFIER, USER_TOKEN, VERIFY_WALLET } from "../../Utils/constant";
import { useEffect, useState } from "react";
import cogoToast from "cogo-toast-react-17-fix";
import Loader from "../Loader";
import useRefreshToken from "../../Hooks/usegenerateToken";
import API from "../../ApiConfig"
import { convertDateFormat, Delay, parseBlobError, resetDocument } from "../../Utils/helper";
import SlideUpWrapper from "../Transitions/SlideUpWrapper";
import { BUTTONS } from "../../Utils/Strings";
import Icon from "react-icons-kit";
import { pencil } from "react-icons-kit/icomoon/pencil";
import ReactPortalModal from "../ReactPortalModal";
import { useDispatch, useSelector } from "react-redux";
import { plus } from "react-icons-kit/fa/plus";
import { androidArrowBack } from "react-icons-kit/ionicons/androidArrowBack";
import { updateUser } from "../../Utils/Redux/UserSlice";
import { useNavigate } from "react-router-dom";
import { fetchCart } from "../../Utils/Redux/CartSlice";
import AddGstIn from "../../pages/AddGstin/AddGSTIN";
import AddDefaultGstIn from "../../pages/AddGstin/AddGSTIN";
// const AddGstIn=({enterGstIn, setEnterGstIn, setGstinPopup})=>{


//   const [gstinInput, setGstinInput]=useState("")
//   const [confirmGstinInput, setConfirmGstIn]=useState("")
//   const [loading, setLoading]=useState(false)
//   const [EnterGSTIN, setEnterGSTIN]=useState(true)
//   const [showGSTINList, setShowGSTINList]=useState(false)
//   const [GSTINList, setGSTINList]=useState([])

// const [isSetAsDefault, setIsSetAsDefault]=useState(false)
//   const User=useSelector(state=>state.User)

//   const[gstinError, setGstinError]=useState("")
//   const AddGSTIN=()=>{
//       if (gstinInput === "") {
//           setGstinError("Enter GSTIN");
//       } 
//       else if (confirmGstinInput === "") {
//           setGstinError("Confirm GSTIN");
//       } 
//       else if (gstinInput.length !== 15) {
//           setGstinError("Enter valid GSTIN");
//       } 
//       else if (confirmGstinInput !== gstinInput) {
//           setGstinError("Confirm GSTIN not matched, try again");
//       }
//       else{
//           setGstinError("")
//       setLoading(true)
//       let apiData={
//           user_id:User.user_id,
//           gstin:gstinInput,
//           set_is_default:isSetAsDefault
//       }
//       API.post(ADD_GSTIN, apiData)
//       .then(res=>{
//           if(res.data.status==200){
//               setLoading(false)
//               setGstinInput("")
//               setConfirmGstIn("")
//               setIsSetAsDefault(false)
//               setEnterGSTIN(false)
//               getUsergstin()
//           }
          
//       })
//       .catch(err=>{
//           setLoading(false)
//           setGstinError(err.response?.data?.message|| "Something went wrong")

//       })}

//   }


//   const getUsergstin=()=>{
//     API.get(GET_USER_GSTIN+User.user_id)
//     .then(res=>{
//       if(res.data.status==200){
//         setShowGSTINList(true)
//         setGSTINList(res.data.data)
//       }
      
//     })
//     .catch(err=>{
//       cogoToast.error(err.reponse.data.message)
//     })
//   }
//   const setAsDefault=(gstinId)=>{
//     let apiData={
//       user_id:User.user_id,
//       gstin_id:gstinId
//     }
//     API.put(SET_DEFAULT_GSTIN,apiData)
//     .then(res=>{
//       if(res.data.status==200){
//         setGstinPopup(false)
//         cogoToast.success(res.data.message)
//         window.location.reload()
//       }

//     })
//     .catch(err=>{
//       cogoToast.error(err.response.data.message)
      
//     })
//   }
//   return(

//   (EnterGSTIN ?
//     <div className="relative z-10 w-[28rem] max-w-full rounded-2xl bg-white p-6 shadow-lg">
// {gstinError&&
// <div
//         style={{
//           backgroundColor: "#fee2e2",
//           color: "#b91c1c",
//           padding: "0.75rem 1rem",
//           borderRadius: "8px",
//           marginBottom: "1rem",
//           fontWeight: "500",
//           textAlign: "center",
//         }}
//       >
//         {gstinError}
//       </div>}
//   <header className="mb-4 flex items-center gap-3">
// <div className="flex-1">

// <p className="text-lg text-slate-600">
//   Please enter a valid 15-character GSTIN.
// </p>
// </div>
// </header>

// {/* GSTIN input */}
// <div className="mb-4">
// <label>Enter GSTIN</label>
// <div style={{margin:"10px, 0px"}}>
// <input
// type="text"
// value={gstinInput}
// onChange={(e) => {setGstinInput(e.target.value.toUpperCase());
//   if(gstinError){
//       setGstinError("")
//   }
// }}
// placeholder="Enter GSTIN (e.g. 27ABCDE1234F1Z5)"
// maxLength={15}
// className="rounded-md border px-3 py-2 text-sm focus:outline-none"
// style={{width:"75%", margin:"4px 0px", border:"1px solid rgb(206, 200,200)"}}
// />
// {gstinInput.includes(" ") && (
// <p className="text-sm text-red-500">
//   GSTIN cannot contain spaces.
// </p>
// )}
// </div>
// </div>
// <div className="mb-4">
// <label>Confirm GSTIN</label>
// <div>
// <input
// type="text"
// value={confirmGstinInput}
// onChange={(e) => {setConfirmGstIn(e.target.value.toUpperCase());
//   if(gstinError){
//       setGstinError("")
//   }
// }}
// placeholder="Confirm GSTIN.."
// maxLength={15}
// className="rounded-md border px-3 py-2 text-sm focus:outline-none"
// style={{width:"75%", margin:"4px 0px", border:"1px solid, rgb(206, 200, 200)"}}
// />
// </div>
// {confirmGstinInput.includes(" ") && (
// <p className="text-sm text-red-500">
//   GSTIN cannot contain spaces.
// </p>
// )}
// </div>
// {/* <div>
//   <label style={{display:"flex",alignItems:"center"}}>
//     <>
//     <input
//         type="checkbox"
//         checked={isSetAsDefault}
//         onChange={(e) => setIsSetAsDefault(e.target.checked)}
//         aria-label="Set as default GSTIN"
//       />
//       <span style={{ marginLeft: "8px" }}>Set as default</span>
//     </>
//   </label>
// </div> */}
// <footer className="mt-6 flex justify-end gap-3">

//     <button
//       type="button"
//       onClick={()=>AddGSTIN()}
//       className="btn btn-primary"
//     >
//       Add
//     </button>
//   </footer>
// </div>: showGSTINList?
// <div style={{margin:"15px"}}>
// {GSTINList && GSTINList.map((item,index)=>(
// <div key={item.id} style={{width:"inherit", margin:"10px"}} className="input" onClick={()=>{setAsDefault(item.id)}}>
//   <label className={styles.gstinList}>
//   <>
// <input type="radio" readOnly />
// <div style={{width:"100%"}}>
// <div style={{fontSize:"18px", fontWeight:"700", padding:"10px 0px"}}>{item.legal_name}</div>
// <div style={{display:"flex", justifyContent:"space-between"}}>
// <span>{item.gstin}</span>
// <span style={{color:item.gstin_status=="Active"?"green":"red"}}>{item.gstin_status}</span>
// </div>
// </div>
// </>
// </label>
// </div>
// ))}
// <div>
// <button className="btn btn-primary" onClick={()=>setEnterGSTIN(true)}>Add New</button>
// </div>
// </div>:null)
// )}
const UserSelection = ({ data, setupdateUser }) => {
  const [selected, setSelected] = useState("");
  const [enterUseremail, setUserEmail]=useState(false)

  const User=useSelector(state=>state.User)
  const [selectedRoleName, setSelectedRoleName]=useState("")
  const [email, setEmail]=useState("")
  const [emailError, setEmailError]=useState("")
  const dispatch=useDispatch()
  const handleSelectRoleType=(roleType)=>{
    if(roleType=="Admin"){
      if(User.user_type=="Issuer"){
        setSelectedRoleName("ADMIN_ISSUER")
      }
      else if(User.user_type=="Verifier"){
        setSelectedRoleName("ADMIN_VERIFIER")
      }
    }
    else if(roleType=="MEMBER"){
      if(User.user_type=="Issuer"){
        setSelectedRoleName("MEMBER_ISSUER")
      }
      else if(User.user_type=="Verifier"){
        setSelectedRoleName("MEMBER_VERIFIER")
      }
    }
    setUserEmail(true)
  };

  const UpdateUserRole=(e)=>{
    e.preventDefault()
    if(User.email!==""){
    let apiData={
      user_id:User.user_id,
      email:data.email,
      role_name:selectedRoleName
    }
    API.post(UPDATE_USER_ROLE, apiData)
  .then(res => {
    cogoToast.success(res.data.message);
    setupdateUser(false);
    setEmailError("");

    const updatedEmail = apiData.email;   // email you sent to API

    if (updatedEmail === User.email) {
      dispatch(updateUser({
        user_role_name: res.data.data.new_role
      }));
    }

    setTimeout(() => {
      window.location.reload();
    }, 500)
  })
  .catch(err => {
    setEmailError(err.response?.data?.message || "Something went wrong");
  })
  }
  else{
    setEmailError("Enter Email")
  }
  }
  console.log(selectedRoleName);
  
  const baseStyles =
    "cursor-pointer border rounded-2xl p-5 flex items-center justify-center gap-3 text-lg font-medium transition-all w-40";

  const activeStyles =
    "border-blue-600 bg-blue-50 text-blue-700 shadow-md scale-105";

  const inactiveStyles =
    "border-gray-300 bg-white text-gray-700 hover:bg-gray-100";

  return (
    <div className="flex flex-col items-center gap-6 p-2">
      {enterUseremail ?
      <div style={{width:"85%"}}>
      <label className="block font-medium mb-10"><div className='cursor-pointer mb-10' style={{display:"flex", alignItems:"center"}}><span onClick={()=>{setUserEmail(false);setEmailError("")}}><Icon icon={androidArrowBack} size={18}/></span><span style={{marginLeft:"10px"}}>Email</span></div></label>
      <input
        type="email"
        placeholder="Enter client email"
        className="mb-10 input"
        value={data.email}
        disabled
        // onChange={(e)=>handleEmailChange(e)}
      />

{emailError && (
<p className="text-red-500 text-sm mb-4">{emailError}</p>
)}
<div className="text-center">
          <button className='btn btn-primary' onClick={(e)=>UpdateUserRole(e)}> Submit </button>

</div>
</div>
      :
      <>
      <h2 className="text-xl font-semibold">Select User Role</h2>

      <div className="flex gap-6">
        {/* Admin */}
        <div
          className={`${baseStyles} ${
            selectedRoleName === "Admin" ? activeStyles : inactiveStyles
          }`}
          onClick={() => handleSelectRoleType("Admin")}
        >
          👤 <span>Admin</span>
        </div>

        {/* Member */}
        <div
          className={`${baseStyles} ${
            selectedRoleName === "MEMBER" ? activeStyles : inactiveStyles
          }`}
          onClick={() => handleSelectRoleType("MEMBER")}
        >
          👥 <span>Member</span>
        </div>
      </div>
      </>}
    </div>
  );
}
const ProfileForm = ({ companyProfile, isProfileUser }) => {
  const CartDetails=useSelector(state=>state.cart.user)
  resetDocument()
  useRefreshToken(BASE_URL + USER_TOKEN)

  const [disabled, setDisabled] = useState(false)
  const [loading, setLoading] = useState(true)
  const [save, setsave] = useState(false)

  const [companyName, setCompanyName] = useState(companyProfile.company_name);
  const [CompanyLogo, setLogo] = useState({ url: companyProfile.logo_path ? companyProfile.logo_path : '/imac27gallery1-3@2x.png', file: null })
  const [AddressLine1, setAddressLine1] = useState(companyProfile.address1 || "");
  const [AddressLine2, setAddressLine2] = useState(companyProfile.address2 || "");
  const [Email, setEmail] = useState(companyProfile.email);
  const [Phone, setPhone] = useState(companyProfile.phone_number);
  const [amount, setAmount]=useState({})
  const wallet = useSelector((state) => state.cart.wallet);

  const [Gstin, setGstin]=useState(companyProfile.gstin)
  const [Pan, setPan]=useState(companyProfile.pan)
  const [updateGstin, setUpdateGstin]=useState(false)
  const [updateUser, setUpdateUser]=useState(false)
  const [AccountType, setAccountType]=useState(companyProfile.account_type)
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
  const [RoleUserData, setRoleUserData]=useState("")
  const [ccEmail, setCcEmail]=useState(companyProfile.bulk_upload_cc_email)
  const [DisableCcEmail, setDisableCCEmail]=useState(true)
  const UserDetails=useSelector(state=>state.cart.user)
  const User=useSelector(state=>state.User)
  const navigate=useNavigate()
  const dispatch=useDispatch()
  const showLogoImage = (image) => {
    let valid = false
    // console.log(image.target.files[0].size)
    const checkValid = () => {
      if (image.target.files[0].type == 'image/png') {
        valid = true
      }
      if (image.target.files[0].size < 100) {
        valid = true
      }
    }
    checkValid()
    try {
      if (valid) {
        setLogo({ url: URL.createObjectURL(image.target.files[0]), file: image.target.files[0] })
      }
      else {
        cogoToast.error("Please upload only PNG files")
      }
    }
    catch {
      cogoToast.error("Some Error Occured, Please Upload Again")
    }
    finally {
      image.target.value = null;
    }
    // console.log(CompanyLogo)
  }

  useEffect(() => {
    if (companyProfile.name != null) {
      setLoading(false)
    }
    if (!isProfileUser && companyProfile.address1 && companyProfile.address2)
      setDisabled(true)
    setCompanyName(companyProfile.company_name);
    setAddressLine1(companyProfile.address1 || "");
    setAddressLine2(companyProfile.address2 || "");
    setEmail(companyProfile.email);
    setPhone(companyProfile.phone_number);
    setLogo({ url: (companyProfile.logo_path || '/imac27gallery1-3@2x.png'), file: null })
    setGstin(companyProfile.gstin)
    setPan(companyProfile.pan)
    setAccountType(companyProfile.account_type)
    setCcEmail(companyProfile.bulk_upload_cc_email)
    const initialAmounts = {};
    companyProfile.user_list &&companyProfile.user_list.forEach((u) => {

      initialAmounts[u.user_id] = ""; // or 0
    });

    setAmount(initialAmounts)
    const initial = {};
    companyProfile.user_list &&companyProfile.user_list.forEach((u) => {
      initial[u.user_id] = { startDate: "", endDate: "" };
    });
    setDateRange(initial)
  }, [companyProfile])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (disabled) {
      cogoToast.error("Profile already updated.", { position: "top-right" })
    }
    else {
      if (CompanyLogo.url != '/imac27gallery1-3@2x.png' && AddressLine1 != "" && CompanyLogo.url != null) {
        setLoading(true)

        const formData = new FormData();
        formData.append('company_name', companyName)
        formData.append('address1', AddressLine1)
        formData.append('address2', AddressLine2)
        formData.append('email', Email)
        formData.append('phone_number', Phone)
        if (CompanyLogo.file)
          formData.append('logo', CompanyLogo.file)
        if (ccEmail)
          formData.append('bulk_upload_cc_email', ccEmail)
        setsave(true)
        await Delay()
        let URL = companyProfile.user_type === 'Verifier' ? UPDATE_VERIFIER : UPDATE_ISSUER
        API.post(URL, formData)
          .then(data => {
            let res = data.data
            if (res.success == true) {
              cogoToast.success("Profile Updated", { position: "top-right" })
              setTimeout(() => {
                window.location.reload()
                setLoading(false)
              }, 1500);
            }

            else {
              cogoToast.error("Some Error occured. please check again.", { position: "top-right" })
              setLoading(false)
            }
          })
          .catch(err => {
            cogoToast.error(err.message, { position: "top-right" })
            setLoading(false)
          })
          .finally(() => setsave(false))
      }
      else {
        cogoToast.error("Please insert address and logo")
      }
    }
  }
  const handleReset = (e) => {
    e.preventDefault()
    if (disabled) {
      cogoToast.error("Profile already updated.", { position: "top-right" })
    }
    else {
      setAddressLine1(companyProfile.address1 || "");
      setAddressLine2(companyProfile.address2 || "");
      setPhone(companyProfile.phone_number);
    }
  }
  const handleRole=(i)=>{
    setUpdateUser(true)
    setRoleUserData(i)
  }
  
  

  const initiateRazorpayPayment = async (user_amount, userDetail) => {
          setLoading(true)
          try {
              const response = await fetch(`${BASE_URL}${ADD_MONEY}`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                      user_id: userDetail.user_id,
                      amount:user_amount
                  })
              });
  
              const order = await response.json();
              if (!response.ok) {
                  setLoading(false)
                  throw new Error(order.message || "Failed to initiate payment");
              }
              return new Promise((resolve, reject) => {
                  const options = {
                      key: order.data.key_id,
                      amount: order.data.amount,
                      currency: wallet.currency,
                      name: "AuthNumber",
                      description: order.data.description,
                      order_id: order.data.razorpay_order_id,
                      handler: async function (response) {
                          // Step 3: Verify Payment on Backend
                          const verifyResponse = await fetch(`${BASE_URL}${VERIFY_WALLET}`, {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify({
                                  user_id: userDetail.user_id,
                                  razorpay_order_id: response.razorpay_order_id,
                                  razorpay_payment_id: response.razorpay_payment_id,
                                  razorpay_signature: response.razorpay_signature
                              })
                          });
  
                          const result = await verifyResponse.json();
                          if (verifyResponse.ok) {
                              setLoading(false)
                              resolve(true); // Payment success
                          } else {
                              setLoading(false)
                              resolve(false); // Payment failed
                          }
                      },
                      modal: {
                          ondismiss: function () {
                            setLoading(false);
                            // Cancel the transaction when payment dialog is closed
                            fetch(`${BASE_URL}api/v1/payment/cancel-transaction`, {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify({
                                razorpay_order_id: order.data.razorpay_order_id
                              })
                            })
                            .then(response => response.json())
                            .then(result => {
                              AuthConsole("Transaction cancelled:", result);
                              window.location.reload()
                            })
                            .catch(error => {
                              console.error("Error cancelling transaction:", error);
                            });
                            resolve(false);
                          }
                        },
                      prefill: {
                          name: userDetail?.name,
                          email: userDetail?.email,
                          contact: UserDetails?.phone_number
                      },
                      theme: { color: "#3399cc" }
                  };
  
                  const rzp1 = new window.Razorpay(options);
                  rzp1.open();
              });
          } catch (error) {
              setLoading(false)
              console.error("Payment initiation error:", error);
              return false;
          }
      }

  const AddMoneyToWallet = async (e, user) => {
    e.preventDefault()
          if(user.currency==="USD"){
              if(amount[user.user_id]>=1 && amount[user.user_id]<=100){
                  const response = await initiateRazorpayPayment(amount[user.user_id],user)
                  if (response) {
                    setAmount("100")
                    if(User.user_id==user.user_id){
                    dispatch(fetchCart(User.user_id))
                    setTimeout(()=>{
                      window.location.reload()
                    },750)
                    }
                  else{
                    window.location.reload()
                  }
                }
              }
              else {
                  cogoToast.error("Invalid amount! You can add between $1 to $100")
          }
      }
          else if(user.currency!=="USD"){
           if (amount[user.user_id] >=1 && amount[user.user_id] <= 25000) {
              const response = await initiateRazorpayPayment(amount[user.user_id], user);
              if (response) {
                setAmount("100")
                if(User.user_id==user.user_id){
                dispatch(fetchCart(User.user_id))
                setTimeout(()=>{
                window.location.reload()
                },750)
                }
              else{
                window.location.reload()
              }
              }
          }
              else {
                  cogoToast.error(`Invalid amount! You can add between ${ wallet.currency=="USD"?'$1':'₹1'} to ${ wallet.currency=="USD"?'$100':'₹25000'}`)
              }
          }
      }
      const handleAmountChange = (id, value) => {
        setAmount(prev =>({
          ...prev,
          [id]:value
        }
          )
        );
      }



      const handleDateChange = (id,field, e) => {
        setDateRange((prev) => ({ ...prev, 
         [id]:{ 
          ...prev[id],
          [field]: e }
        }));
      }

      const downloadSearchRecords = async (e,user) => {
          e.preventDefault();
      
          setLoading(true);
          if (dateRange[user.user_id].startDate !== "" && dateRange[user.user_id].endDate !== "") {
            const apiData = {
              verifier_id: user.verifier_id,
              start_date: convertDateFormat(dateRange[user.user_id].startDate),
              end_date: convertDateFormat(dateRange[user.user_id].endDate),
            };
      
            API.post(EXPORT_REQUESTS, apiData, { responseType: "blob" })
              .then((res) => {
                if (res.status == 200) {
                  setDateRange((prev) => ({
                    ...prev,
                    [user.user_id]: {
                      startDate: "",
                      endDate: ""
                    }
                  }));
                  setDateRange((prev) => ({
                    ...prev,
                    [user.user_id]: {
                      startDate: "",
                      endDate: ""
                    }
                  }));
                  const blob = new Blob([res.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  });
      
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement("a");
      
                  link.href = url;
                  link.download = `${dateRange[user.user_id].startDate}_to_${dateRange[user.user_id].endDate}.xlsx`;
                  document.body.appendChild(link);
                  link.click();
      
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                  window.location.reload()
                }
              })
              .catch(async (err) => {
                cogoToast.error(await parseBlobError(err));
              })
              .finally(() => {
                setLoading(false);
              });
          } else {
            setLoading(false);
            cogoToast.error("Enter Valid Start and End Date");
          }
        }
  return (
    <form className={styles.fileUploadInputField} >
      <Loader isOpen={loading} />
      <div className={styles.content}>
        <div className={styles.footerContainer}>Company Name</div>
        <div className={styles.inputContent}>
          {loading ? (
            <div className='shimmer' style={{ width: '30rem', height: '2.5rem' }} />
          ) : (
            <input type="text" className={styles.input} value={companyName} placeholder="e.g ABC Company" onChange={(e) => setCompanyName(e.target.value)} disabled />
          )}
        </div>
    {User.user_type=="Super Admin" && companyProfile.issuer_state&&
        <div>
          <button className="btn btn-primary" onClick={()=>navigate("/adjustCredit/"+companyProfile.email, {state:{company_name:companyName}})}> Adjust Wallet</button>

        </div>}
      </div>
      <div className={styles.content}>
        <div className={styles.footerContainer}>User Type</div>
        <div className={styles.inputContent}>
          {loading ? (
            <div className='shimmer' style={{ width: '30rem', height: '2.5rem' }} />
          ) : (
            <input type="text" className={styles.input} value={AccountType} placeholder="B2C" onChange={(e) => setAccountType(e.target.value)} disabled />
          )}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.footerContainer}>CC Email</div>
        <div className={styles.inputContent}>
          {loading ? (
            <div className='shimmer' style={{ width: '30rem', height: '2.5rem' }} />
          ) : (
            <div className="display-flex">
            <input type="text" className={` mb-10 mr-10 ${styles.input}`} value={ccEmail} placeholder="abc@authbridge.com" onChange={(e) => setCcEmail(e.target.value)} disabled={DisableCcEmail} />
            {companyProfile.bulk_upload_cc_email==ccEmail&&  <div onClick={()=>setDisableCCEmail(!DisableCcEmail)}><Icon icon={pencil} size={18} /></div>}
            </div>
          )}
        </div>
      </div>
      {companyProfile.user_list &&companyProfile.user_list.map((roleName, index)=>(
      <div className={styles.content} style={{border:"1px solid lightgray", padding:"1rem", borderRadius:"10px"}}>
        <div className={styles.footerContainer}>Company User {index+1}</div>
        <div className={styles.inputContent}>
          {loading ? (
            <div className='shimmer' style={{ width: '30rem', height: '2.5rem' }} />
          ) :
           (
            <>
            <input type="text" className={`mb-10 ${styles.input}`} key={index} value={roleName.name} placeholder="NA" disabled />
            <div className="display-flex">
            <input type="text" className={`mb-10 mr-10 ${styles.input}`} key={index} value={roleName.role_name ? roleName.role_name.replace(/_/g, " ") : "NA"} placeholder="NA" disabled />
            {User.user_role_name=="ADMIN_VERIFIER" || User.user_role_name=="ADMIN_ISSUER"?<div className="cursor-pointer" style={{marginTop:"7px"}} onClick={()=>handleRole(roleName)} title="Change Role"><Icon icon={pencil} size={18} /></div>:""}
            </div>
            <input type="text" className={`mb-10 ${styles.input}`} key={index} value={roleName.email} placeholder="NA" disabled />
      {User.user_type=="Verifier" && User.user_role_name=="ADMIN_VERIFIER"&&<>  <div className={styles.footerContainer} style={{display:"flex", alignItems:"center", width:"100%"}}><div className="mr-2">Amount: {roleName.currency==="USD"?"$":"₹"}{roleName.wallet_balance}</div><div>
        <input type="text" className={`${styles.AmountInput} w-25` } key={index} value={amount[roleName.user_id] || ""} placeholder="Add Amount" onChange={(e)=>handleAmountChange(roleName.user_id, e.target.value)} />
          </div><div><button className="btn btn-primary" onClick={(e)=>AddMoneyToWallet(e, roleName)}>Recharge</button></div></div>
          <div className={`${styles.footerContainer} mt-2`} style={{display:"flex", alignItems:"center", width:"100%"}}><div className="mr-2">Download Search Records</div></div>
          <div className={`${styles.footerContainer}`} style={{display:"flex", alignItems:"center", width:"100%"}}>
          <div className="mb-10 flex justify-between">
        <div>
            <input
                          type="date"
                          className="datePicker"
                          value={dateRange[roleName.user_id].startDate}
                          onChange={(e) => {handleDateChange(roleName?.user_id,"startDate", e.target.value)}}
                        />
                        <input
                          type="date"
                          className="datePicker"
                          value={dateRange[roleName.user_id].endDate}
                          style={{margin:"10px 0px 0px 25px"}}
                          onChange={(e) => {handleDateChange(roleName.user_id,"endDate", e.target.value)}}
                        />
        </div>
        </div>
      {dateRange[roleName.user_id].startDate&& dateRange[roleName.user_id].endDate &&  <div><button className="btn btn-primary" onClick={(e)=>downloadSearchRecords(e, roleName)}>{`Export Search (CSV)`}</button></div>}
      </div>
            </>
          }

            </>
          )}
        </div>
      </div>))}
      <div className={styles.divider} />
      <div className={styles.frameAppsIcons}>
        <div className={styles.authnumberlogoInstance}>
          <div className={styles.avatarFrame}>Logo</div>
          <div className={styles.supportingText}>
            This will be displayed on Company profile.
          </div>
        </div>
        <div className={styles.LogoBox}>
          <div className={styles.image3} style={loading ? { border: 'none' } : null}>
            {loading ? (
              <div className='shimmer' style={{ height: "100%" }} />
            ) : (
              <>
                <img className={styles.imac27Gallery13Icon} loading="eager" alt="" src={CompanyLogo.url} />
                {!disabled && <img className={styles.trashIcon} alt="" src="/trash.svg" onClick={() => setLogo({ url: '/imac27gallery1-3@2x.png', file: null })} />}
              </>
            )}
          </div>
          {!disabled && !loading && (
            <div className={styles.textNavItem}>
              <div className={styles.dividerContentInputfield}>
                <label for="fileInput" style={{cursor:'pointer'}}>
                  <div className={styles.button}>
                    <img className={styles.uploadOutlineIcon} alt="" src="/uploadoutline.svg" />
                    Upload Logo
                    <input type="file" id="fileInput" style={{ display: "none" }} className={styles.fileInput} onChange={(e) => showLogoImage(e)} disabled={disabled} accept="image/png, image/jpeg" />
                  </div>
                </label>
                <span className={styles.uploadHelp}>Recommended size 1440x1440 px *Only PNG allowed</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.content}>
        <div className={styles.footerContainer}>Address</div>
        <div className={styles.inputContent}>
          <div className={styles.label}>Line 1</div>
          {loading ? (
            <div className='shimmer' style={{ width: '30rem', height: '2.3rem' }} />
          ) : (
            <input type="text" className={styles.input} value={AddressLine1} placeholder="Address 1" onChange={(e) => setAddressLine1(e.target.value)} disabled maxLength='200' />
          )}
          <div className={styles.label}>Line 2</div>
          {loading ? (
            <div className='shimmer' style={{ width: '30rem', height: '2.5rem' }} />
          ) : (
            <input type="text" className={styles.input} value={AddressLine2} placeholder="Address 2" onChange={(e) => setAddressLine2(e.target.value)} disabled maxLength='200' />
          )}
        </div>
      </div>
      <div className={styles.divider} />
      <div className={styles.contentEmail}>
        <div className={styles.footerContainer}>Email</div>
        {loading ? (
          <div className='shimmer' style={{ width: '30rem', height: '2.5rem' }} />
        ) : (
          <div className={styles.inputwithIcon}>
            <img className={styles.envelopeOutlineIcon} alt="" src="/envelopeoutline.svg" />
            <input type="email" disabled className={styles.input} value={Email} placeholder="Contact@test.com" />
          </div>
        )}
      </div>
      <div className={styles.contentEmail}>
        <div className={styles.footerContainer}>Phone no.</div>
        {loading ? (
          <div className='shimmer' style={{ width: '30rem', height: '2.5rem' }} />
        ) : (
          <div className={styles.inputwithIcon}>
            <img className={styles.envelopeOutlineIcon} alt="" src="/phoneoutline.svg" />
            <input type="tel" disabled className={styles.input} value={Phone} placeholder="0987654321" onChange={(e) => setPhone(e.target.value)} maxLength={10} minLength={10} />
          </div>
        )}
      </div>
      {(CartDetails?.is_offshore === false || User?.user_type === "Super Admin") && (
  <>
      {companyProfile.gstin_list && companyProfile.gstin_list.map((gstin, index)=>(
      <div className={styles.contentEmail} style={{display:"flex"}}>
      <div className={styles.footerContainer}>GSTIN {index+1}</div>
      {loading ? (
        <div className="shimmer" style={{ width: "30rem", height: "2.5rem" }} />
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <input
            type="tel"
            disabled
            className={styles.input}
            value={gstin.gstin}
            placeholder="27ABCDE1234F1Z5"
            onChange={(e) => setGstin(e.target.value)}
            maxLength={15}
            minLength={15}
          />
          {User.user_role_name!=="MEMBER_VERIFIER"&& User.user_role_name!=="MEMBER_ISSUER" && User.user_type!=="Super Admin" && gstin.is_default && (
            <div style={{ border:"1px solid gray", borderRadius:"100px",cursor: "pointer", padding:"4px" }} onClick={() => setUpdateGstin(true)} title="Update GST">
              <Icon icon={plus} size={18} />
            </div>
          )}
        </div>
      )}
      </div>))}

    <div className={styles.contentEmail}>
      <div className={styles.footerContainer}>PAN</div>
      {loading ? (
        <div className="shimmer" style={{ width: "30rem", height: "2.5rem" }} />
      ) : (
        <input
          type="tel"
          disabled
          className={styles.input}
          value={Pan}
          placeholder="0987654321"
          onChange={(e) => setPan(e.target.value)}
          maxLength={10}
          minLength={10}
        />
      )}
    </div>
  </>
)}
      <div className={styles.divider} />

      {!disabled && <div className={styles.actions}>

        <button className="btn btn-secondary" onClick={handleReset} disabled={loading || save}>{BUTTONS.RESET}</button>
        <div>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={loading || save}>
            {save ? BUTTONS.SAVING : BUTTONS.SAVE}
          </button>
        </div>
      </div>}

      <div className={styles.divider} />
      <ReactPortalModal isOpen={updateGstin} title="GSTIN UPDATE" blockOutsideClick={true} onClose={()=>setUpdateGstin(false)}>
                                  <AddDefaultGstIn setGstinPopup={setUpdateGstin}/>
                  </ReactPortalModal>

                  <ReactPortalModal isOpen={updateUser} title="Update User Role" blockOutsideClick={true} onClose={()=>{setUpdateUser(false); setRoleUserData("")}}>
                                  <UserSelection  data={RoleUserData} setupdateUser={setUpdateUser}/>
                  </ReactPortalModal>
    </form>
  );
};

export default ProfileForm;
